module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_8023.856431bb.png";